export default {
    data() {
        return {
            districtList: [],
        }
    },
    methods: {
        async searchDistrictByDivision() {
            let tempString = '';
            if (this.searchParam) {              
                this.searchParam.district_code = undefined;
                this.searchParam.thana_code = undefined;
                this.searchParam.post_office_code = undefined;
                tempString = `division_code=${this.searchParam.division_code}`;
            }
            if (this.getSchema) {
                
                this.getSchema.district_code = undefined;
                this.getSchema.thana_code = undefined;
                this.getSchema.post_office_code = undefined;
                tempString = `division_code=${this.searchParam.division_code}`;
            }
           
            await this.$store.dispatch('callDistrictData', {
                page: 1,
                size: -1,
                search: tempString
            });
            this.districtList = await this.$store.getters.getDistrictItem;
           //  console.log(this.getSchema);
        }
    }
}
